"use strict";

exports.__esModule = true;
exports.DataRangeSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DataRangeSelector = exports.DataRangeSelector = function DataRangeSelector(props) {
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataRangeSelector.dataRange.label", "Data Range"),
    helperText: translate("DataRangeSelector.dataRange.helperText", "The data range to show in the widget.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    value: element.props.dataRange || "",
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "dataRange", e.target.value || undefined);
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: ""
  }, translate("DataRangeSelector.dataRange.reportingPeriod.label", "Reporting Period")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "SELECTION"
  }, translate("DataRangeSelector.dataRange.selection.label", "Selection")))));
};